<div class="allFAQS" *ngFor="let FAQ of FAQs; let i=index;">
    <div class="borderaround">
        <div>

            <a *ngIf="!FAQ.expander" (click)="FAQ.expander = !FAQ.expander"><i
                    class="fa-solid fa-circle-plus fa-lg"></i><span class="action">{{FAQ.faqQuestion}}</span></a>
            <a *ngIf="FAQ.expander" (click)="FAQ.expander = !FAQ.expander"><i
                    class="fa-solid fa-circle-minus fa-lg"></i><span class="action">{{FAQ.faqQuestion}}</span></a>
        </div>
        <div class="row innerexpand" *ngIf="FAQ.expander">
            <div class="col-12">

                <div class="questionanswer">{{FAQ.faqAnswer}}</div>

            </div>

        </div>
    </div>
    <div class="twentypxtop"></div>
</div>